// MODAL DIALOGS
// ----------------------------------------------------------------------------
$(function () {
    var $body = $('body');

    $.fn.extend({
        showModal: function () {
            var closeOverlay = function() {
                $('[data-modal="modal"]').hide();
                $('[data-modal="modal"]').removeClass('is--visible');
                $('.modal-dialog').hide();
                $('.mt-tooltip').remove();
                $body.removeClass('is--modal-open');
                $('.is--in-front').removeClass('is--in-front');
            };

            var createOverlay = function() {
                $('.mt-overlay').remove();
                var $overlay = $('<div>', {
                    id: 'm-new',
                    class: 'mt-overlay',
                    click: function() {
                        closeOverlay();
                    }
                });
                $overlay.appendTo($body);
            };


            $(document).on('click', '[data-modal="close"]', function(e){
                closeOverlay();
                e.preventDefault();
            });

            return this.each(function () {
                var modalId = $(this).attr('href');
                var $modal = $(modalId);
                createOverlay();

                $(this).click(function (e) {
                    $body.addClass('is--modal-open');
                    //$modal.show();
                    $modal.addClass('is--visible');
                    e.preventDefault();
                });
            });
        }
    });

    $('[data-modal="open"]').showModal();
});


    // OLD FUNCTION
    // --------------------------------------------------------
    $(function () {
        var $body = $('body');

        $.fn.extend({
            showModalLegacy: function (options) {
                var defaults = {
                    top: 50,
                    closeButton: '.modal-close'
                };

                options = $.extend(defaults, options);

                return this.each(function () {
                    var o = options;

                    $(this).click(function (e) {
                        var modalId = $(this).attr('href');

                        var closeOverlay = function() {
                            $('[data-modal="modal"]').hide();
                            $('.modal-dialog').hide();
                            $('.mt-tooltip').remove();
                            $body.removeClass('is--modal-open');
                            $('.is--in-front').removeClass('is--in-front');
                        };

                        var createOverlay = function() {
                            $('.mt-overlay').remove();

                            var $overlay = $('<div>', {
                                id: 'm-legacy',
                                class: 'mt-overlay',
                                click: function() {
                                    closeOverlay();
                                }
                            });
                            $overlay.appendTo($body);
                        };

                        createOverlay();

                        $(o.closeButton).click(function () {
                            closeOverlay();
                        });

                        var modalHeight = $(modalId).outerHeight();
                        var modalWidth = $(modalId).outerWidth();

                        $body.addClass('is--modal-open');

                        $(modalId).css({
                            // 'display': 'block',
                            'position': 'fixed',
                            'opacity': 0,
                            // 'z-index': 100010,
                            'left': 50 + '%',
                            'margin-left': -(modalWidth / 2) + 'px',
                            'top': o.top + '%',
                            'margin-top': -(modalHeight / 2) + 'px'
                        });

                        $(modalId).fadeTo(100, 1);

                        e.preventDefault();
                    });
                });
            }
        });
        $('a[rel*=modal-dialog]').showModalLegacy();
    });
